export default __webpack_public_path__ + "static/media/lp-sec08_main.499c7636.png";